import type { State } from 'src/replicant/State';

import {
  payloadComputedProperty,
  SB,
  searchableComputedProperty,
} from '@play-co/replicant';
import { tuple } from '../utils/types';
import { getCurrentEvolution, getPetAge } from './pet.getters';
import { species } from './pet.ruleset';
import * as Fate from '../fate';
import { getStressValue } from './pet.getters';

export const petProperties = {
  petSpecies: searchableComputedProperty(
    SB.tuple(tuple(...species, '')),
    (state: State) => getCurrentEvolution(state)?.species ?? '',
  ),

  petName: payloadComputedProperty(
    SB.string(),
    (state: State) => state.pet.name ?? '',
  ),

  petAge: payloadComputedProperty(SB.number(), (state: State, api) =>
    getPetAge(state, api.date.now()),
  ),

  /**
   * Current pet state
   */
  petState: searchableComputedProperty(
    SB.tuple(Fate.ruleset.fateState),
    (state: State, api) =>
      Fate.getters.getCurrentPetState(state, api.date.now(), true),
  ),

  /**
   * If player one of this state we will increase to change to be first in visiting list
   */
  petStateSorting: searchableComputedProperty(
    SB.number(),
    (state: State, api) => Fate.getters.getPetStateScore(state, api.date.now()),
  ),

  /**
   * Current pet state
   */
  petStress: searchableComputedProperty(
    SB.number(),
    (state: State, api) =>
      Math.floor(getStressValue(state, api.date.now()) / 10) * 10,
  ),

  /**
   * Pet on daycare
   */
  petIsInDaycare: searchableComputedProperty(
    SB.boolean(),
    (state: State, api) =>
      Fate.getters.hasPermanentStatusEffect(state, 'daycare', api.date.now()),
  ),
};
